import FolderPath from "./FolderPath";
import { useState, useEffect } from "react";

export function getCurrentFiscalYear() {
  const today = new Date("2025-09-08");
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const fyFull = month >= 9 ? year + 1 : year;
  return (fyFull % 100).toString().padStart(2, "0");
}

export function getFiscalMonths() {
  return [
    "September","October","November","December",
    "January","February","March","April",
    "May","June","July","August"
  ];
}

export default function Delivery() {
  const trackBaseUrl = "tracks/delivery/technology/";

  const START_FY = 23;

  const [fiscalYears, setFiscalYears] = useState(() => {
    const currentFY = parseInt(getCurrentFiscalYear(), 10);
    return Array.from({ length: currentFY - START_FY + 1 }, (_, i) =>
      (START_FY + i).toString().padStart(2, "0")
    );
  });

  useEffect(() => {
    const updateFY = () => {
      setFiscalYears(prev => {
        const last = parseInt(prev[prev.length - 1], 10);
        const current = parseInt(getCurrentFiscalYear(), 10);

        if (current > last) {
          const missing = Array.from(
            { length: current - last },
            (_, i) => (last + i + 1).toString().padStart(2, "0")
          );
          return [...prev, ...missing];
        }
        return prev;
      });
    };

    updateFY();
    const interval = setInterval(updateFY, 3600000);
    return () => clearInterval(interval);
  }, []);

  const foldersDetail = {
    level1: [
      "DevOps","Agile","SRE","Security","IE","DLF",
      "SI","AO","PM","Tech Arch","Leadership"
    ],
    level2: ["Artifacts","Archives"],
    level3: fiscalYears,
    level4: getFiscalMonths()
  };

  return <FolderPath trackBaseUrl={trackBaseUrl} foldersDetail={foldersDetail} />;
}
